import { BODY_FONT, TITLE_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { DoubleTitleOptions } from '../types'

export class DoubleTitle implements TicketElement {
  first: string
  second: string
  paddingTop: number
  paddingBottom: number
  boxHeight: number
  firstFont: string
  secondFont: string
  firstLineHeight: number
  secondLineHeight: number

  constructor(
    first: string,
    second: string,
    { firstStyle, secondStyle, firstLineHeight, secondLineHeight }: DoubleTitleOptions = {}
  ) {
    this.first = first
    this.second = second
    this.paddingTop = 30
    this.paddingBottom = 20
    this.firstLineHeight = firstLineHeight || 70
    this.secondLineHeight = secondLineHeight || 45
    this.boxHeight = this.firstLineHeight + this.secondLineHeight
    this.firstFont = `${firstStyle || 'bold 60px'} ${TITLE_FONT}`
    this.secondFont = `${secondStyle || '40px'} ${BODY_FONT}`
  }

  height(): number {
    return this.paddingTop + this.boxHeight + this.paddingBottom
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top, width, this.boxHeight)
    ctx.fillStyle = 'white'
    ctx.textBaseline = 'middle'
    ctx.textAlign = 'center'
    ctx.font = this.firstFont
    ctx.fillText(this.first, width / 2, top + this.firstLineHeight / 2)
    ctx.font = this.secondFont
    ctx.fillText(this.second, width / 2, top + this.firstLineHeight + this.secondLineHeight / 2)
  }
}
